import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { WhyUs } from "../components/WhyUs";
import { Coverage } from "../components/Coverage";
import { Pricing } from "../components/Pricing";
import { Testimonials } from "../components/Testimonials";
import { QuoteForm } from "../components/QuoteForm";
import { Footer } from "../components/Footer";
import { FloatingButtons } from "../components/FloatingButtons";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: { offset: -80 } });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyUs />
        <Coverage />
        <Pricing />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
